import React, { useState, useEffect, useContext } from 'react';
import {withRouter} from "../../lib/react/withRouter";

import * as net from "../../lib/net";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Vip_Bo extends React.Component {
    constructor(props, context) {
        super(props);

        this.webStore = props.store;
        this.state = {};
        this.state.seldate = new Date();
        this.state.avd = "01";
        this.state.paa = [];
        this.state.aa = [];

        this.state.mna = [];
        this.state.mna.push({ mnid: "mn01", pos: "c1", text: "KONTON", desc: "Konton för redovisning", link: "/vip/bo/konto" });
        this.state.mna.push({ mnid: "mn04", pos: "c2", text: "PARAMETRAR", desc: "Lojalitets parametrar", link: "/vip/bo/prm" });
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }
    componentDidMount() {
    }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
    fknGo(url) {
        //alert(row.href);
        var row = {};
        row.url = url;
        sso.seo.sfkn = row;
        this.props.navigate(url);
    }

    render() {
        return (
            <div className="web-app">
                <div className="web-pg py-4 flex">
                    <h3>Statistik</h3>
                    <p>Statistik funktioner</p>

                    <div className="divider_green"></div>

                    <div className="web-row">
                        <div className="flex-col flex">
                            { this.mnc("c1").map((row, key) =>
                                <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                                    <div>{ row.text }</div>
                                    <div className="flex-row">
                                        <div className="flex">{ row.desc }</div>
                                        <div className="web-link">Välj</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="flex-col flex">
                            { this.mnc("c2").map((row, key) =>
                                <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                                    <div>{ row.text }</div>
                                    <div className="flex-row">
                                        <div className="flex">{ row.desc }</div>
                                        <div className="web-link">Välj</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Vip_Bo);
